import React, { PropsWithChildren } from 'react';
import TabPanel, {TabPanelRef} from "devextreme-react/tab-panel";
import Form, { GroupItem, Label, SimpleItem } from "devextreme-react/form";

interface FormListTabProductProps {
  cacherProduct?: any;
  _setCacherProduct?: any;
}

const FormListTabProduct = React.forwardRef<TabPanelRef<any, any>, PropsWithChildren<FormListTabProductProps>>(({ children}, ref) => {

  if (!ref || !children) return <></>;
  return (
    <TabPanel id={"tabPanel"} scrollByContent={true} showNavButtons={true} ref={ref}>
      {children}
    </TabPanel>
  );
});
export default FormListTabProduct;